import { z } from 'zod'
import { oc } from '@orpc/contract'
import { splitPlanSchema } from '../../model/incoming-fax/split-plan.schema'

// Who is on each page of a fax (PD-1988): the per-page OCR read, the pages that belong to one
// patient, the chart to suggest for each, and where a split filing stands. `dob` is MM/DD/YYYY.
export const getIncomingFaxPatients = oc
  .route({ method: 'GET', path: '/v2/incoming-faxes/{id}/patients' })
  .input(z.object({ id: z.string() }))
  .output(
    z.object({
      status: z.enum(['pending', 'completed', 'failed', 'not-run']),
      pageCount: z.number().int(),
      pages: z.array(
        z.object({
          pageNumber: z.number().int(),
          status: z.enum(['patient', 'none', 'unreadable']),
          name: z.string().nullable(),
          dob: z.string().nullable(),
        }),
      ),
      groups: z.array(
        z.object({
          pages: z.array(z.number().int()),
          suggestedPages: z.array(z.number().int()),
          name: z.string(),
          dob: z.string().nullable(),
          suggestedPatient: z
            .object({ id: z.string(), display: z.string(), birthDate: z.string() })
            .nullable(),
        }),
      ),
      split: z
        .object({
          state: z.enum(['in-progress', 'completed']),
          plan: splitPlanSchema.nullable(),
          filed: z.array(
            z.object({
              documentReferenceId: z.string(),
              patientId: z.string(),
              patientDisplay: z.string(),
              title: z.string(),
              pages: z.array(z.number().int()),
            }),
          ),
        })
        .nullable(),
    }),
  )
